<template>
  <el-dialog
    :title="`${$t('storage::out-stock::add_export')}${
      type === 'in' ? $t('storage::out-stock::add_in_bill') : $t('storage::out-stock::bill')
    }`"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
    @closed="tempList = []"
  >
    <el-upload
      style="margin-left: 10px; text-align: center"
      ref="upload"
      :action="uploadUrl"
      accept=".xls,.cvs,.xlsx"
      :http-request="UploadImage"
      :show-file-list="false"
      drag
      v-if="!skuList.length"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        {{ $t('storage::out-stock::add_upload_drag') }}
        <em>{{ $t('storage::out-stock::add_upload_click') }}</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        {{ $t('storage::out-stock::add_upload_template') }}
        <el-button type="text" @click="getImportTemplate">{{ $t('storage::out-stock::add_download') }}</el-button>
      </div>
    </el-upload>
    <z-table v-else :columns="columns" :data="skuList" :max-height="400" :pagination="false" class="prodinfo--table">
      <template #skuId="{ row }">
        <span>{{ row.skuId }}{{ row.skuProperty ? '-' + row.skuProperty : '' }}</span>
      </template>
      <template #spuName="{ row }">
        <div class="prodinfo--table__imgTd">
          <el-popover placement="top-start" trigger="hover">
            <img :src="row.img" style="width: 250px; height: 250px" />
            <img :src="row.img" slot="reference" />
          </el-popover>
          <div>
            <div>{{ row.title }}</div>
            <div>{{ row.categoryName }}</div>
          </div>
        </div>
      </template>
    </z-table>
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('storage::out-stock::add_cancel') }}</el-button>
      <el-button type="primary" @click="addSku">{{ $t('storage::out-stock::add_add') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getImportTemplate, importStockOrder } from '@/server/stock'
import { downloadBlobFile } from '@/utils'
export default {
  props: {
    value: {},
    type: {
      type: String,
      default: ''
    },
    supplier: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      visible: this.value,
      uploadUrl: `${process.env.VUE_APP_BASEURL}/ocean/api/v1/product/stock/import`,
      skuList: [],
      tableColumns: [
        {
          label: 'SKU',
          prop: 'skuId',
          width: 150
        },
        {
          label: this.$t('storage::out-stock::add_prod_name'),
          prop: 'spuName',
          minWidth: 120
        },
        {
          label: this.$t('storage::out-stock::add_out_count'),
          prop: 'qty',
          minWidth: 100
        },
        {
          label: this.$t('storage::out-stock::add_total_amount'),
          prop: 'totalPrice',
          minWidth: 100
        }
      ]
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.skuList = []
      }
    },
    visible (val) {
      this.$emit('input', val)
    }
  },
  computed: {
    columns () {
      return this.type === 'in' ? this.tableColumns : this.tableColumns.slice(0, -1)
    }
  },
  methods: {
    async UploadImage (file, fileList) {
      const fdata = new FormData()
      fdata.append('file', file.file)
      fdata.append('supplier_id', this.supplier)
      //这里写axios请求，
      const { data } = await importStockOrder(fdata)
      if (data.code === this.$code) {
        this.skuList = data.data
        this.$message.success(this.$t('system::tip::in_success'))
      }
    },
    addSku () {
      this.$emit('addSku', this.skuList)
      this.visible = false
    },
    async getImportTemplate () {
      const url =
        this.type === 'in'
          ? '//ocean-img.algobuy.net/default/cae8b6493dec4d82a9edc78684fb192b.xlsx'
          : '//ocean-img.algobuy.net/default/7373174654f74823ac8dd572c7b7024c.xlsx'
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.download = 'template.xlsx'
      document.body.appendChild(link)
      link.click()
      // const res = await getImportTemplate()
      // if (res.code === this.$code) {
      //   downloadBlobFile(
      //     res.response.data,
      //     {
      //       type: res.response.data.type
      //     },
      //     'template.xlsx'
      //   )
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.prodinfo--table {
  &__imgTd {
    display: flex;
    align-items: center;
    padding: 10px 0;
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}
</style>
